"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var googlebooks_1 = require("./googlebooks");
exports.toCSL = googlebooks_1.toCSL;
